import { Component, OnInit, ViewChild } from '@angular/core';
import { gridPageRequest } from '../../../model/common/common.model';
import { SharedModule } from '../../../shared/shared.module';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { receiptLookupComponent } from '../receipt-Report-lookup/receipt-lookup.component';
import { ReportLookupComponent } from '../../Reports/report-lookup/report-lookup.component';
import _ from 'lodash';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PurchaseorderService } from '../../../services/purchaseorder.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-purchase-order-receipt-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './purchase-order-receipt-lookup.component.html',
  styleUrl: './purchase-order-receipt-lookup.component.scss'
})
export class PurchaseOrderReceiptLookupComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;


  selectedPOrder: any[] = [];
  searchKey: any;
  paginator: boolean | undefined;
  VendorName: any;
  isReturnPOContext: boolean = false;


  constructor(private route: Router, private porderservice: PurchaseorderService, private confirmationService: ConfirmationService,
    private messageService: MessageService, public dialogService: DialogService, public ref: DynamicDialogRef, private config: DynamicDialogConfig) {
  }

  loader: boolean = false;

  POReceiptList: any;

  pageRequest: gridPageRequest = {
    pageIndex: 1,
    pageSize: 20,
    id: 0
  }

  Status: any[] = [
    { name: 'Ready' },
    { name: 'Process' },
    { name: 'Close' },
  ];

  selectedStatus: any;

  ngOnInit(): void {
    this.selectedStatus = { name: 'Process' };
    this.isReturnPOContext = this.config.data?.isReturnPO || false;
    //document.title = 'Receipt List';
    this.VendorName = this.config.data?.selectedCustomerName;
    if (this.isReturnPOContext) {
      this.getReceiptReturnPO();
    } else {
      this.getReceipt();
    }
  }

  getReceipt() {
    this.porderservice.getPOReceiptHeader(this.pageRequest).subscribe({
      next: (data: any) => {
        this.POReceiptList = data.poReceiptHeader;
        if (this.VendorName) {
          this.POReceiptList = this.POReceiptList.filter(
            (receipt: any) => receipt.vendor?.vendorName === this.VendorName
          );
        }

        this.POReceiptList = this.POReceiptList.filter(
          (receipt: any) => receipt.poReceiptStatus === 'Close'
        );

      },
      error: (error) => {
        console.error(error);
      }
    });
  }


  getReceiptReturnPO() {
    this.porderservice.getPOReceiptForReturnPO(this.pageRequest).subscribe({
      next: (data: any) => {
        this.POReceiptList = data.poReceiptHeader;
        if (this.VendorName) {
          this.POReceiptList = this.POReceiptList.filter(
            (receipt: any) => receipt.vendor?.vendorName === this.VendorName
          );
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  onstatus() {
    this.getReceipt();
  }

  deleteReceipt() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        if (this.selectedPOrder && this.selectedPOrder.length > 0) {

          var selectedOrdersWithReadyStatus = _.filter(this.selectedPOrder, { 'poReceiptStatus': 'Ready' });
          var poReceiptHeaderIds = _.map(selectedOrdersWithReadyStatus, 'poReceiptHeaderId');
          if (poReceiptHeaderIds && poReceiptHeaderIds.length > 0) {
            this.porderservice.deletePOReceiptHeader(poReceiptHeaderIds).subscribe({
              next: () => {
                this.selectedPOrder = [];
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
                this.getReceipt();
              },
              error: () => {

              }
            });
          }
        }
      },
      reject: () => {
      }
    });

  }

  editReceipt(data?: any) {
    if (data) {
      this.route.navigate(['/home/create-receipt'], { queryParams: { 'poReceiptHeaderId': data.poReceiptHeaderId }, skipLocationChange: false },);
    } else {
      this.route.navigate(['/home/create-receipt'], { queryParams: { 'poReceiptHeaderId': this.selectedPOrder[0].poReceiptHeaderId }, skipLocationChange: false },);
    }
  }

  loadReceipt(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getReceipt();
  }

  showReport(value: any) {
    this.ref = this.dialogService.open(ReportLookupComponent, {
      header: `Receipt Order`,
      width: '100%',
      data: { OrderNo: value.poReceiptNumber, ReportName: 'Receipt' }

    });

  }

  searchReceipt() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    if (this.isReturnPOContext) {
      const searchKeyLower = this.searchKey.toLowerCase();

      this.POReceiptList = this.POReceiptList.filter((receipt: { poReceiptNumber: string; vendor: { vendorName: string; }; purchaseOrderNumber: string; challenNo: string; }) => {
        return receipt.poReceiptNumber?.toLowerCase().includes(searchKeyLower) ||
          receipt.vendor?.vendorName?.toLowerCase().includes(searchKeyLower) ||
          receipt.purchaseOrderNumber?.toLowerCase().includes(searchKeyLower) ||
          receipt.challenNo?.toLowerCase().includes(searchKeyLower);
      });

      this.paginator = false;
    } else {
      this.porderservice.searchPOReceipt(this.searchKey).subscribe(
        (data: any) => {
          if (Array.isArray(data)) {
            this.POReceiptList = data;
          } else if (data && Array.isArray(data.poReceiptHeader)) {
            this.POReceiptList = data.poReceiptHeader;
          } else {
            this.POReceiptList = [];
            console.warn('No receipts found or incorrect format', data);
          }
          this.pageRequest.pageSize = this.POReceiptList.length;
          this.paginator = false;
        },
        (error) => {
          console.error('Search error:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
        }
      );
    }
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;

    if (this.isReturnPOContext) {
      this.getReceiptReturnPO();
    } else {
      this.getReceipt();
    }
  }

  receipts(poReceiptHeaderId: any) {
    this.ref = this.dialogService.open(receiptLookupComponent, {
      header: 'Print Receipt Reports',
      width: '50%',
      data: { poReceiptHeaderId: poReceiptHeaderId }
    });
  }


  SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }

}
